import { Routes } from '@angular/router';

import type { SeoRouteData } from '../core/seo/seo.types';

/** Shared portal auth routes (mounted at `/portal` and `/:tenantSlug/portal`). */
export const tenantPortalRoutes: Routes = [
  {
    path: 'login',
    data: { seo: { title: 'Portal sign in', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/login/tenant-login-page.component').then((m) => m.TenantLoginPageComponent),
  },
  {
    path: 'student-login',
    data: { seo: { title: 'Student sign in · Admission number', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/login/tenant-admission-login-page.component').then((m) => m.TenantAdmissionLoginPageComponent),
  },
  {
    path: 'register',
    data: { seo: { title: 'Register your organisation', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/register/tenant-register-page.component').then((m) => m.TenantRegisterPageComponent),
  },
  {
    path: 'register/verify-otp/:tenantId',
    data: { seo: { title: 'Verify OTP', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/register/tenant-otp-verify-page.component').then(
        (m) => m.TenantOtpVerifyPageComponent,
      ),
  },
  {
    path: 'forgot-password',
    data: { seo: { title: 'Reset password', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/forgot-password/tenant-forgot-password-page.component').then((m) => m.TenantForgotPasswordPageComponent),
  },
  {
    path: 'reset-password',
    data: { seo: { title: 'Set new password', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/reset-password/tenant-reset-password-page.component').then((m) => m.TenantResetPasswordPageComponent),
  },
  {
    path: 'select',
    data: { seo: { title: 'Select organisation', robots: 'noindex, nofollow' } satisfies SeoRouteData },
    loadComponent: () =>
      import('./pages/tenant-switcher/tenant-switcher-page.component').then((m) => m.TenantSwitcherPageComponent),
  },
];
